var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xD0\x9E\xD0\x9E\xD0\x9E"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 363"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 361"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9529 16.1846C12.9529 16.1846 12.9529 16.1846 12.9529 16.877C12.9529 17.5695 15.3764 17.5695 16.0689 18.2619C16.7613 18.9544 17.1076 20.3392 17.1076 20.3392",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M10.1833 16.1846C10.1833 16.1846 10.1833 16.1846 10.1833 16.877C10.1833 17.5695 7.75979 17.5695 7.06734 18.2619C6.3749 18.9544 6.02867 20.3392 6.02867 20.3392",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2",
    d: "M14.3378 13.7754C14.0044 14.9815 12.6067 16.1841 12.122 16.1839C11.6373 16.1837 11.9143 16.1841 11.0141 16.1839C10.1139 16.1837 9.07999 15.0204 8.79824 13.7754C8.5165 12.5304 8.45232 11.6832 8.79824 10.7648C9.14417 9.84631 9.49069 9.60542 10.1831 9.25945C10.8756 8.91348 12.2605 8.91355 12.9529 9.25945C13.6454 9.60536 13.9915 9.84631 14.3378 10.7648C14.6841 11.6832 14.6712 12.5693 14.3378 13.7754Z",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M11.5662 19.1846V21.0311",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 361_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M19.4407 11C19.502 12 19.0005 12 18.5029 12.5",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M21.0048 11C21.0009 11.5 21.0005 12 22.0019 12.5",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2_2",
    d: "M22.0557 9.19651C21.8218 10.0039 20.8414 10.8088 20.5014 10.8087C20.1614 10.8085 20.3557 10.8088 19.7242 10.8087C19.0928 10.8085 18.3676 10.0299 18.1699 9.19651C17.9723 8.36313 17.9273 7.79607 18.1699 7.18128C18.4126 6.56649 18.6556 6.40525 19.1414 6.17367C19.6271 5.94209 20.5985 5.94213 21.0842 6.17367C21.5699 6.40521 21.8127 6.56649 22.0557 7.18128C22.2986 7.79607 22.2895 8.38916 22.0557 9.19651Z",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M3.79419 11C3.7957 11.5 4.00122 12 4.50018 12.5",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M2.66919 11C2.6674 11.5 2.30908 11.7312 1.50301 12.5",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 2_3",
    d: "M1.17836 9.19651C1.41233 10.0039 2.39326 10.8088 2.73344 10.8087C3.07363 10.8085 2.87923 10.8088 3.51099 10.8087C4.14275 10.8085 4.86834 10.0299 5.06607 9.19651C5.2638 8.36313 5.30884 7.79607 5.06607 7.18128C4.8233 6.56649 4.58011 6.40525 4.09414 6.17367C3.60818 5.94209 2.63625 5.94213 2.15029 6.17367C1.66432 6.40521 1.42142 6.56649 1.17836 7.18128C0.935299 7.79607 0.944389 8.38916 1.17836 9.19651Z",
    stroke: "#DBDBDB",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/ООО.50a93ae71febaf0f940988003633c89e.svg";
export { ForwardRef as ReactComponent };